import { aqFetch } from "./api";

export const getStaffStats = async ({ dateFrom, dateTo }) => {
  const params = new URLSearchParams();
  if (dateFrom) params.set("date_from", dateFrom);
  if (dateTo) params.set("date_to", dateTo);

  const query = params.toString();
  const response = await aqFetch(
    `departments/staff-stats${query ? `?${query}` : ""}`,
    { method: "GET" },
  );

  if (!response.ok) {
    const errorText = await response.text();
    let message = `Ошибка загрузки HR-статистики: ${response.status}`;
    try {
      const err = JSON.parse(errorText);
      if (err.detail) message = String(err.detail);
    } catch {
      if (errorText) message = errorText;
    }
    throw new Error(message);
  }

  return response.json();
};

export const patchDepartmentHeadcountPlans = async (plans) => {
  const response = await aqFetch("departments/headcount-plans", {
    method: "PATCH",
    body: JSON.stringify({ plans }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    let message = `Ошибка сохранения плана: ${response.status}`;
    try {
      const err = JSON.parse(errorText);
      if (Array.isArray(err.detail)) {
        message = err.detail.map((item) => item.msg || String(item)).join("; ");
      } else if (err.detail) {
        message = String(err.detail);
      }
    } catch {
      if (errorText) message = errorText;
    }
    throw new Error(message);
  }

  return response.json();
};
